import type { ListSessionsDto } from "@/client";
import type { PreviewState } from "@/components/custom/data-table/data-table-preview";
import type { TableFiltersContextValue } from "@/components/custom/data-table/data-table-context";
import { createPicker } from "@/components/custom/table-view/search-namespace";

// The sessions table's filters: All Filters resets its form to these, and the chips, the active state
// and Clear all read them. Every key here must also be in `namespaced` below -- DataTableNavigationProvider
// builds the query from `namespaced.extract(search)`, so a filter it leaves out is written to the URL on
// Apply and then dropped before the request (ID-7091). -sessions-search.test.ts holds the two together.
export const sessionsDefaultFilters: NonNullable<
  TableFiltersContextValue<ListSessionsDto>["defaultFilters"]
> = {
  // sessionId: undefined,
  deviceIds: undefined,
  storageDeviceIds: undefined,
  clusterIds: undefined,
  siteIds: undefined,
  from: undefined,
  to: undefined,
  storage: undefined,
  headBlurred: undefined,
  labels: undefined,
  tagIds: undefined,
  tagsMatch: undefined,
  onlyNonScans: undefined,
  alertType: undefined,
  assistantId: undefined,
  shopperId: undefined,
  timeField: [undefined, "session"],
  sessionsTagsMatch: undefined,
  sessionTagIds: undefined,
  devicesTagsMatch: undefined,
  devicesTagIds: undefined,
  assigneeIds: undefined,
  assigneeMatch: [undefined, "any"],
  datasetId: undefined,
};

export const namespaced = createPicker<
  Partial<ListSessionsDto> & { position?: number; preview?: PreviewState }
>()([
  "limit",
  "sortBy",
  "page",
  "position",
  "preview",
  "deviceIds",
  "storageDeviceIds",
  "clusterIds",
  "siteIds",
  "from",
  "to",
  "timeField",
  "sessionId",
  "tagIds",
  "tagsMatch",
  // "onlyNonScans",
  "alertType",
  "assistantId",
  "shopperId",
  "sessionTagIds",
  "sessionsTagsMatch",
  "devicesTagIds",
  "devicesTagsMatch",
  "assigneeIds",
  "assigneeMatch",
  "storage",
  "headBlurred",
  "labels",
  "datasetId",
]);

export type Search = ReturnType<(typeof namespaced)["forward"]>;

/** The profile key of the Sessions layout (ID-6898); the dataset Sessions tab shares it. */
export const SESSIONS_TABLE_KEY = "data.sessions";
/** The page sizes the Sessions table offers; a saved `pageSize` outside them is not seeded. */
export const SESSIONS_PAGE_OPTIONS: number[] = [20, 50, 100, 200];
/** The page size a URL without one gets when nothing is saved to the profile. */
export const SESSIONS_DEFAULT_PAGE_SIZE = 200;
